export default defineNuxtRouteMiddleware(async (to) => {
  const nuxtApp = useNuxtApp()
  const locale = nuxtApp.$i18n.locale.value

  return navigateTo({
    path: `/${locale}/user-zone/bookings`,
    query: to.query
  })
})
